import Parse from '../../parseConfig';

export const BUILT_HOME_ACCESS_ROLE_NAMES = Object.freeze([
  'XXqHkoY1Rd-Admin',
  'XXqHkoY1Rd-User',
  'PlanHubAdmin',
]);

export async function getBuiltHomeAccessRoles() {
  const roleQuery = new Parse.Query(Parse.Role);
  roleQuery.containedIn('name', BUILT_HOME_ACCESS_ROLE_NAMES);
  roleQuery.limit(BUILT_HOME_ACCESS_ROLE_NAMES.length);

  const roles = await roleQuery.find();
  const rolesByName = new Map(roles.map((role) => [role.get('name'), role]));
  const missingRoleNames = BUILT_HOME_ACCESS_ROLE_NAMES.filter((name) => !rolesByName.has(name));

  if (missingRoleNames.length) {
    throw new Error(`Built Home access role${missingRoleNames.length === 1 ? '' : 's'} not found: ${missingRoleNames.join(', ')}`);
  }

  return BUILT_HOME_ACCESS_ROLE_NAMES.map((name) => rolesByName.get(name));
}

export function createBuiltHomeAcl(roles) {
  const acl = new Parse.ACL();

  roles.forEach((role) => {
    acl.setRoleReadAccess(role, true);
    acl.setRoleWriteAccess(role, true);
  });

  return acl;
}

export function hasCanonicalBuiltHomeAcl(object) {
  const aclJson = object?.getACL?.()?.toJSON?.() || {};
  const principalNames = Object.keys(aclJson);
  const expectedPrincipalNames = BUILT_HOME_ACCESS_ROLE_NAMES
    .map((name) => `role:${name}`)
    .sort();

  if (
    principalNames.length !== expectedPrincipalNames.length
    || [...principalNames].sort().some((name, index) => name !== expectedPrincipalNames[index])
  ) {
    return false;
  }

  return expectedPrincipalNames.every((principalName) => {
    const permissions = aclJson[principalName];
    return permissions?.read === true
      && permissions?.write === true
      && Object.keys(permissions).length === 2;
  });
}

export async function userHasBuiltHomeAccessRole(user = Parse.User.current()) {
  if (!user) {
    return false;
  }

  const roles = await getBuiltHomeAccessRoles();
  const membershipResults = await Promise.all(roles.map(async (role) => {
    const usersQuery = role.getUsers().query();
    usersQuery.equalTo('objectId', user.id);
    return usersQuery.first();
  }));

  return membershipResults.some(Boolean);
}
